import { call, put } from "redux-saga/effects";
import { categoryApi } from "@services/api/category/categoryApi";
import { getAllCategoriesActions } from "../slices";

function* getAllCategoriesWorker({ payload }) {
  yield put(getAllCategoriesActions.pending());
  try {
    const response = yield call(categoryApi.getAllCategories, payload);
    yield put(getAllCategoriesActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllCategoriesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllCategoriesWorker };
